import { useAtomValue } from 'jotai';

import {
  LocalAudioVideoThumbnail,
  LocalAudioVideoThumbnailProps,
} from '../session/session-grid/LocalAudioVideoThumbnail';
import { visitorNameAtom } from './state';

export function SelfVideoThumbnail(props: Omit<LocalAudioVideoThumbnailProps, 'name'>) {
  const visitorName = useAtomValue(visitorNameAtom);

  return <LocalAudioVideoThumbnail {...props} name={visitorName} />;
}
